export const organizationAccessGroupsLabelV813 = (
  subject,
  allLabel = 'ALL'
) => {
  if (subject?.all_access) return allLabel;
  return (subject?.access_groups || []).join(', ');
};

export const organizationAllowedModelsLabelV813 = (
  subject,
  allLabel = 'ALL'
) => {
  if (subject?.all_access) return allLabel;
  return subject?.allowed_models?.length || 0;
};

export const organizationGroupSummaryV813 = (
  organization,
  allLabel = 'ALL'
) => {
  if (organization?.all_access) return allLabel;
  return organization?.allowed_groups?.length || 0;
};
